import { For, Show } from "solid-js"
import { delayTone, formatClock, formatDelay, formatProgress } from "../lib/format"
import { mapController } from "../map/controller"
import { app } from "../store/app"
import { RouteBadge } from "./RouteBadge"

export function RouteView() {
  const found = () => app.selectedRoute()

  return (
    <Show when={found()} fallback={<div class="panel-body"><div class="empty">route not found</div></div>}>
      {(item) => (
        <div class="panel-body">
          <div class="hero">
            <RouteBadge route={item().route} />
            <div>
              <div class="hero-title">{item().route.description}</div>
              <div class="muted">{item().agency.name}</div>
            </div>
          </div>

          <div class="action-row">
            <button
              class={`btn${app.isRouteEnabled(item().route.id) ? " primary" : ""}`}
              onClick={() => app.setRouteEnabled(item().route.id, !app.isRouteEnabled(item().route.id))}
            >
              {app.isRouteEnabled(item().route.id) ? "visible on map" : "show on map"}
            </button>
            <button class="btn" onClick={() => mapController.fitRoute(item().route.id)}>
              fit map
            </button>
          </div>

          <h3 class="section-title">Live buses ({app.vehiclesForSelectedRoute().length})</h3>
          <Show
            when={app.vehiclesForSelectedRoute().length}
            fallback={<div class="empty">{app.loadingDetail() ? "loading…" : "no active vehicles right now"}</div>}
          >
            <div class="vehicle-list">
              <For each={app.vehiclesForSelectedRoute()}>
                {(vehicle) => (
                  <button
                    class={`vehicle-card${app.selectedVehicleId() === vehicle.id ? " selected" : ""}`}
                    onClick={() => app.openVehicle(vehicle.id)}
                  >
                    <div class="vehicle-top">
                      <strong>{vehicle.headsign || "trip"}</strong>
                      <span class={`delay ${delayTone(vehicle.delay)}`}>{formatDelay(vehicle.delay)}</span>
                    </div>
                    <div class="muted">
                      {[
                        vehicle.nextStopName ? `next: ${vehicle.nextStopName}` : null,
                        formatProgress(vehicle.progress),
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                    </div>
                    <Show when={vehicle.progress != null}>
                      <div class="progress">
                        <div
                          class="progress-fill"
                          style={{
                            width: `${Math.round((vehicle.progress || 0) * 100)}%`,
                            background: `#${app.routeColor(vehicle.routeId, vehicle.routeColor)}`,
                          }}
                        />
                      </div>
                    </Show>
                  </button>
                )}
              </For>
            </div>
          </Show>

          <h3 class="section-title">Schedule</h3>
          <Show when={app.loadingDetail() && !app.schedule()}>
            <div class="empty">loading schedule…</div>
          </Show>
          <Show when={!app.loadingDetail() && !app.schedule()?.directions?.length}>
            <div class="empty">no schedule available</div>
          </Show>
          <For each={app.schedule()?.directions || []}>
            {(direction) => {
              const upcoming = () =>
                (direction.trips || [])
                  .map((trip) => ({
                    trip,
                    time: trip.firstDeparture ?? trip.stopTimes?.[0]?.departure ?? trip.stopTimes?.[0]?.arrival ?? 0,
                  }))
                  .filter((t) => t.time)
                  .slice(0, 12)

              return (
                <div class="schedule-block">
                  <div class="schedule-head">
                    {direction.headsigns?.filter(Boolean).join(" / ") || `direction ${direction.directionId}`}
                  </div>

                  <Show when={upcoming().length} fallback={<div class="empty">no trips listed</div>}>
                    <div class="schedule-table">
                      <For each={upcoming()}>
                        {(item) => (
                          <div class="schedule-row">
                            <span>{formatClock(item.time)}</span>
                            <span class="muted">{item.trip.headsign || ""}</span>
                          </div>
                        )}
                      </For>
                    </div>
                  </Show>

                  <Show when={direction.stops?.length}>
                    <div class="action-row">
                      <button
                        class="btn"
                        onClick={() =>
                          mapController.showStops(direction.stops, {
                            color: app.routeColor(item().route.id, item().route.color),
                            fit: true,
                          })
                        }
                      >
                        show stops on map
                      </button>
                    </div>
                    <details class="stop-details">
                      <summary>{direction.stops.length} stops</summary>
                      <ol class="stop-list">
                        <For each={direction.stops}>
                          {(stop) => (
                            <li
                              class="clickable-stop"
                              onClick={() => {
                                mapController.showStops(direction.stops, {
                                  color: app.routeColor(item().route.id, item().route.color),
                                })
                                mapController.focusStop(stop.id)
                              }}
                            >
                              {stop.name}
                            </li>
                          )}
                        </For>
                      </ol>
                    </details>
                  </Show>
                </div>
              )
            }}
          </For>
        </div>
      )}
    </Show>
  )
}
